import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

//import theme from '@ecp/common/src/style/theme/default';
import moTheme from '@ecp/common/src/style/theme/mo';
import { Spacing } from '@ecp/common/src/layouts/Spacing';
import { TextBox } from '@ecp/common/src/text/TextBox';
import { DropdownItemWrapper } from '@ecp/common/src/components/unstyled/dropdown/DropdownDefaultComponent';

const SubGoodDropDownItem = ({ subGoodIndex, label, width = '320px', padding = '0 10px' }) => {
  const theme = useTheme();
  return (
  <SubGoodWrapper width={width} padding={padding}>
    {subGoodIndex && (
      <>
        <TextBox color={theme.color.primary} flex-shrink={'0'}>
          {subGoodIndex}
        </TextBox>
        <Spacing left={4} />
      </>
    )}
    <TextBox ellipsis>{label}</TextBox>
  </SubGoodWrapper>
)};

SubGoodDropDownItem.propTypes = {
  width: PropTypes.string,
  padding: PropTypes.string,
  subGoodIndex: PropTypes.string,
  label: PropTypes.string,
};

export default SubGoodDropDownItem;

const SubGoodWrapper = styled(DropdownItemWrapper)`
  flex-shrink: 1;
  height: 40px;
  padding: ${({ padding }) => padding};
  font-size: ${moTheme.font.size.$14};
  font-weight: ${moTheme.font.weight.demiLight};
`;
